import React from "react";

interface EndInterviewModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EndInterviewModal: React.FC<EndInterviewModalProps> = ({ isVisible, onConfirm, onCancel }) => {
  if (!isVisible) return null;

  return (
    <div className="end-interview-modal-overlay" onClick={onCancel}>
      <div className="end-interview-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="end-interview-modal-title">End Interview?</h2>
        <p className="end-interview-modal-description">
          A participant has left the call. Would you like to mark this interview as completed?
        </p>
        <div className="end-interview-modal-actions">
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-preview" onClick={onConfirm}>
            End Interview
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndInterviewModal;
